<template>
  <svg width="72" height="72" xmlns="http://www.w3.org/2000/svg">
    <g fill-rule="nonzero" fill="none">
      <path d="M47 30v-4a1 1 0 0 0-1-1H26a1 1 0 0 0-1 1v4h22z" fill="#FFC760" />
      <path d="M25 32v14a1 1 0 0 0 1 1h5V32h-6z" fill="#6BCFFF" />
      <path d="M33 47h13a1 1 0 0 0 1-1V32H33v15z" fill="#2F75FF" />
    </g>
  </svg>
</template>
